import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import AdminAuthContext from "../store/adminStore/admin-auth-context";

const AdminRequireFormAuth = ({ route }) => {
  const location = useLocation();
  const { clientAuthInfo } = useContext(AdminAuthContext);

  const clientAccessibilities = clientAuthInfo.accessibilities;

  const typeKey = route.path.includes("/add")
    ? "insertAccessList"
    : route.path.includes("/edit")
    ? "updateAccessList"
    : route.path.includes("/view")
    ? "selectAccessList"
    : "";

  let isAuthorized;

  if (route?.entityNames) {
    const foundedObj = clientAccessibilities?.find(
      (clientAcc) => clientAcc.packageName === route.packageName
    );

    let isAuthorizedArray = [];
    for (const entName of route.entityNames) {
      const isAuthorizedForThisEnity = foundedObj[typeKey].includes(entName);
      isAuthorizedArray.push(isAuthorizedForThisEnity);
    }

    isAuthorized = isAuthorizedArray.includes(true);
  } else {
    const foundedObj = clientAccessibilities?.find(
      (clientAcc) => clientAcc.packageName === route.packageName
    );
    isAuthorized = foundedObj ? foundedObj[typeKey]?.includes(route.entityName) : false;
  }
  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        isAuthorized ? (
          <Outlet />
        ) : (
          <Navigate to="/not-authorized" replace state={{ from: location }} />
        )
      ) : (
        <Navigate to="/admin/login" replace state={{ from: location }} />
      )}
    </>
  );
};

export default AdminRequireFormAuth;
